

const Blogs = () => {
    return (<>
        <div>Blogs go here</div>
    </>)
}

export default Blogs;